<template>
  <div class="geolocation-prompt-panel">
    <div class="geolocation-prompt-panel-component hidden">
      <div class="component-background" @click="close" />
      <slide-y-down-transition :duration="1000">
        <div v-show="show" class="wrapper" :class="$store.state.theme">
          <span class="close">
            <i class="fa fa-times-circle fa-lg" @click="close" />
          </span>
          <p style="margin-bottom:10px">
            <img :src="$store.state.geolocationPic" style="height:150px; width:150px" />
          </p>
          <p class="is-size-5">{{ $t("gps.geolocation-request") }}</p>
          <br />
          <span class="button is-warning is-rounded" @click="close">{{ this.$t("next") }}</span>
        </div>
      </slide-y-down-transition>
    </div>
  </div>
</template>


<script>
import EventBus from "../eventBus.js";

export default {
  name: "GeolocationPromptPanel",
  components: {},
  data() {
    return {
      show: false
    };
  },
  computed: {},
  mounted() {
    EventBus.$on("GEOLOCATION_PROMPT", () => (this.show = true));
  },
  activated() {
    if (!this.show) this.close(); // if shown already and somehow get back here, close it
  },
  methods: {
    close() {
      this.show = false;
      var name = ".geolocation-prompt-panel-component";
      setTimeout(() => this.hideComponent(name), 1000);
    }
  }
};
</script>

<style scoped>
.hidden {
  display: none;
}
.component-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.25);
  z-index: 2;
}
.wrapper {
  position: absolute;
  bottom: 0px;
  width: 100vw;
  backdrop-filter: blur(8px);
  background-color: rgba(255, 255, 255, 0.85);
  padding: 18px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.35);
  z-index: 5;
  border-top-right-radius: 25px;
  border-top-left-radius: 25px;
}
.dark {
  background-color: rgba(17, 34, 51, 0.85);
  color: white;
}
.dark .subtitle {
  color: white;
}
.close {
  position: absolute;
  right: 0;
  top: 0;
  padding: 10px;
  color: #f5d252;
  text-shadow: 1px 0px 1px rgba(0, 0, 0, 0.3);
}
</style>